(ns app.front.ui.radio
  (:require [app.front.ui.util :as uiu]
            [core.front.carbon :as cc]
            [potpuri.core :as p]
            [schema-tools.core :as st]))

(defn radio
  "Make a set of radio buttons.

  `:name` is a name (passed to carbon)
  `:values` are selectable values
  `:disabled-values are optional non-selectable values
  `:val->str` a function that make a string from a value
  `:value` the currently selected value
  `:on-change` an event handler for changes, takes the new value
  `:label-text` optional label text
  `:group-class` optional class for cc/radio-button-group
  `:hide-label` visually hides radioset label
  `:hide-button-labels` visually hides radio button labels
  `:required` marks field as required

  other applicable props are also passed to carbon radio-button-group"
  [{:keys [name values disabled-values value val->str val-token on-change label-text class group-class hide-label
           hide-button-labels required]                                                                           :as props}]
  (let [token->value (uiu/make-token->value false val-token values)
        curr-value   (uiu/get-token token->value value)]
    [:div {:class class}
     (when label-text
       [:label.bx--label
        {:class [(when hide-label "bx--visually-hidden") (when required "required-field")]}
        [:span.inline-block label-text]])
     (into (cc/radio-button-group
             (merge (st/select-schema props cc/RadioButtonGroupOptions)
                    {:class-name (str group-class)
                     :on-change  (fn [val]
                                   (-> val token->value :value on-change))}
                    (when (some? curr-value)
                      {:value-selected curr-value})))
           (for [[token {:keys [value]}] (uiu/sort-tokens token->value)]
             (let [id (str name token)]
               (cc/radio-button
                 (p/remove-vals nil?
                                {:name       id
                                 :hide-label hide-button-labels
                                 :id         id
                                 :value      token
                                 :disabled   (contains? disabled-values value)
                                 :label-text ((or val->str str) value)})))))]))
